import React from 'react';
import { motion } from 'framer-motion';
import { Globe } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  NAV_ITEMS,
  NAV_LINK_HOVER,
  LANG_BUTTON_HOVER,
  LANG_BUTTON_TAP,
  CTA_BUTTON_HOVER,
  CTA_BUTTON_TAP,
  NAV_LINK_STYLE,
  handleNavLinkMouseEnter,
  handleNavLinkMouseLeave,
} from './navbarConfig';

const DesktopNav = ({ onNavigate }) => {
  const { language, toggleLanguage, t } = useLanguage();

  return (
    <div className="hidden md:flex items-center space-x-10">
      {NAV_ITEMS.map((item) => (
        <motion.button
          key={item.id}
          whileHover={NAV_LINK_HOVER}
          onClick={() => onNavigate(item.id)}
          data-testid={`desktop-nav-${item.id}`}
          className="text-white/90 hover:text-white font-bold text-base tracking-wide transition-all duration-300 relative group"
          style={NAV_LINK_STYLE}
          onMouseEnter={handleNavLinkMouseEnter}
          onMouseLeave={handleNavLinkMouseLeave}
        >
          {t.nav[item.labelKey]}
          <span className="absolute -bottom-1 left-0 w-0 h-1 bg-gradient-to-r from-orange-500 via-yellow-400 to-blue-400 group-hover:w-full transition-all duration-500 rounded-full shadow-lg shadow-orange-500/50"></span>
        </motion.button>
      ))}

      <motion.button
        whileHover={LANG_BUTTON_HOVER}
        whileTap={LANG_BUTTON_TAP}
        onClick={toggleLanguage}
        data-testid="desktop-language-toggle"
        className="flex items-center space-x-2 px-3 py-2 rounded-lg bg-slate-800 hover:bg-slate-700 transition-colors"
      >
        <Globe className="w-4 h-4 text-blue-400" />
        <span className="text-sm text-white font-medium">{language.toUpperCase()}</span>
      </motion.button>

      <motion.button
        whileHover={CTA_BUTTON_HOVER}
        whileTap={CTA_BUTTON_TAP}
        onClick={() => onNavigate('contact')}
        data-testid="desktop-nav-appointment-btn"
        className="px-6 py-3 rounded-lg bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold hover:shadow-lg hover:shadow-orange-500/50 transition-all"
      >
        {t.nav.getAppointment}
      </motion.button>
    </div>
  );
};

export default DesktopNav;
